module.exports = __webpack_public_path__ + "terms2025.pdf";